import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAnswer,
  clearValidationErrors,
} from "../redux/slices/general-form.slice.js";

export const useFormAnswers = () => {
  const dispatch = useDispatch();
  const { answers, status, error, validationErrors } = useSelector(
    (state) => state.formAnswers
  );

  const setAnswerValue = useCallback(
    (questionId, value) => {
      console.log(
        `useFormAnswers: Setting answer for question ${questionId}:`,
        {
          value,
          valueType: typeof value,
          isArray: Array.isArray(value),
          previousValue: answers[questionId],
        }
      );

      // Validación básica del valor
      if (value === undefined || value === null) {
        console.warn(
          `useFormAnswers: Attempting to set invalid value for question ${questionId}:`,
          value
        );
        return;
      }

      // Para arrays (checkboxes), validar que no esté vacío
      if (Array.isArray(value) && value.length === 0) {
        return;
      }

      // Para strings, validar que no esté vacío
      if (typeof value === "string" && value.trim() === "") {
        return;
      }

      dispatch(setAnswer({ questionId, value }));
    },
    [dispatch, answers]
  );

  const clearAnswers = useCallback(() => {
    dispatch(clearValidationErrors());
  }, [dispatch]);

  const getAnswer = useCallback(
    (questionId) => {
      return answers[questionId];
    },
    [answers]
  );

  const hasAnswer = useCallback(
    (questionId) => {
      const answer = answers[questionId];
      return answer !== undefined && answer !== null && answer !== "";
    },
    [answers]
  );

  const getAnswersCount = useCallback(() => {
    return Object.keys(answers).length;
  }, [answers]);

  const getAllAnswers = useCallback(() => {
    return { ...answers };
  }, [answers]);

  const validateAnswers = useCallback(
    (questions) => {
      if (!questions || !Array.isArray(questions)) {
        return { isValid: false, errors: ["Las preguntas no son válidas"] };
      }

      const errors = [];
      const answerKeys = Object.keys(answers);

      // Verificar que todas las preguntas tengan respuesta
      for (const question of questions) {
        const questionId = question.id;
        const answer = answers[questionId];

        if (answer === undefined || answer === null || answer === "") {
          errors.push(`Pregunta ${questionId} no tiene respuesta`);
        } else if (
          question.type === "multiple_check" &&
          (!Array.isArray(answer) || answer.length === 0)
        ) {
          errors.push(`Pregunta ${questionId} (checkbox) no tiene selecciones`);
        }
      }

      // Verificar que no haya respuestas extra
      for (const answerKey of answerKeys) {
        const questionExists = questions.some((q) => q.id === answerKey);
        if (!questionExists) {
          // Respuesta extra encontrada, pero no es un error crítico
        }
      }

      const isValid = errors.length === 0;

      return { isValid, errors };
    },
    [answers]
  );

  return {
    answers,
    status,
    error,
    validationErrors,
    setAnswerValue,
    clearAnswers,
    getAnswer,
    hasAnswer,
    getAnswersCount,
    getAllAnswers,
    validateAnswers,
  };
};
